import Layout from '@components/layout';
import {
    ClientsPage,
    MarketingPage,
    PushNotifyPage,
    RegFormModal,
    RegFormsPage,
    ReportsPage,
    StatisticsPage,
    TransactionLogPage,
    VisitsPage,
    SourcesPage,
} from '@pages';
import CardsPage from '@pages/crm/cards/CardsPage';
import { RouteConfig } from '@types';

export const crm = (): RouteConfig => {
    return {
        path: 'crm',
        element: <Layout />,
        redirect: 'clients',
        children: [
            {
                path: 'clients',
                element: <ClientsPage />,
                navKey: 'crm.clients',
            },
            {
                path: 'transactions',
                element: <TransactionLogPage />,
                navKey: 'crm.transactions',
            },
            {
                path: 'cards',
                element: <CardsPage />,
                navKey: 'crm.cards',
            },

            {
                path: 'notify',
                element: <PushNotifyPage />,
                navKey: 'crm.notify',
            },
            {
                path: 'clients_origins',
                element: <SourcesPage />,
                navKey: 'crm.origins',
            },
            {
                path: 'clients_visits',
                element: <VisitsPage />,
                navKey: 'crm.visits',
            },
            {
                path: 'marketing',
                element: <MarketingPage />,
                navKey: 'crm.marketing',
            },
            {
                path: 'statistics',
                element: <StatisticsPage />,
            },
            { path: 'reports', element: <ReportsPage /> },
            { path: 'reg_form', element: <RegFormModal /> },
            { path: 'reg_forms', element: <RegFormsPage /> },
        ],
    };
};

export default crm;
